const ROWS = [
  { status: "New", title: "Invite has no way back", tone: "warning" },
  { status: "Fixed", title: "Save looks disabled", tone: "ok" },
  { status: "Open", title: "Empty state has no next step", tone: "muted" },
] as const;

const TONE = {
  warning: "bg-warning-light text-warning-dark",
  ok: "bg-green-100 text-green-800",
  muted: "bg-gray-100 text-gray-600",
};

export default function WeeklyRecheckMock() {
  return (
    <div className="max-w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <ul className="divide-y divide-gray-100">
        {ROWS.map((row) => (
          <li key={row.title} className="flex items-start gap-2 px-3 py-2.5">
            <span
              className={`mt-0.5 shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${TONE[row.tone]}`}
            >
              {row.status}
            </span>
            <span className="min-w-0 text-sm font-semibold leading-snug text-gray-900">{row.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
